export const states = {}

class State {
    constructor(id, value={}) {
        this.id = id
        this.initialValue = {...value}
        this._value = {...value}
    }

    set value(a) {
        this._value = a
    }

    get value() {
        return this._value
    }

    set (...args) {
        let a = this._value
        return Object.assign.apply(a, [a].concat(args))
    }

    reset() {
        this._value = {...this.initialValue}
        return this._value
    }

    clone(elseValue={}) {
        try {
            return JSON.parse(JSON.stringify(this._value))
        } catch(_) {
            return elseValue
        }
    }
}

export const getState = (id, cfg) => {
    if (id in states) return states[id]

    let s = new State(id, cfg)
    states[id] = s
    return s
}




// WEBPACK FOOTER //
// ./src/twd/state.js